import { render, staticRenderFns } from "./AnnexFileView.vue?vue&type=template&id=430b4854&scoped=true"
import script from "./AnnexFileView.vue?vue&type=script&lang=js"
export * from "./AnnexFileView.vue?vue&type=script&lang=js"
import style0 from "./AnnexFileView.vue?vue&type=style&index=0&id=430b4854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430b4854",
  null
  
)

export default component.exports